import React from "react";

import { createRoot } from "react-dom/client";
import "./index.css";

import { App } from "./App";

const root = createRoot(document.getElementById("root") as HTMLElement);
root.render(
  // Re-enable when publishing if possible, and change StrictModeDroppable back
  // to regular droppable (or work out a carevout if possible)
  // <React.StrictMode>
  <App />
  // </React.StrictMode>
);
